/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import Request from './model/Request';
import Response from './model/Response';
import {PulseServiceMap} from './model/Configuration';

export abstract class PulseService {
  public pulseServiceMap: PulseServiceMap;

  protected constructor() {
    this.sendNotifications = this.sendNotifications.bind(this);
    this.pulseServiceMap = {
      POST: this.sendNotifications
    };
  }

  public abstract async sendNotifications(request: Request): Promise<Response>;

  public async pulseServiceHandler(requestData: Request): Promise<Response> {
    const {method} = requestData;

    if (method && method in this.pulseServiceMap) {
      return this.pulseServiceMap[method](requestData);
    }
    throw new Error('Incorrect method requested. Supported: POST');
  }
}
